<script lang="ts">
  import { ResponsiveVars, TwistBox } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import Logo from '../Logos/Logo.svelte';
  import AccessibilityModalButton from '$components/GlobalNav//Accessibility/AccessibilityModalButton.svelte';
  import MobileMenuButton from '$components/Navigation/Mobile/MobileMenuButton.svelte';

  const brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  const responsiveVars = new ResponsiveVars()
    .addFluid('nav-py', toFluidVarInput(9, 6))
    .addFluid('nav-pr', toFluidVarInput(18, 9))
    .addFluid('nav-pl', toFluidVarInput(18, 15))
    .addFluid('left-size', toFluidVarInput(32, 30))
    .addFluid('left-mr', toFluidVarInput(6, 9))
    .addFluid('bar-height', [
      ['lg', 'max', 16, 32],
      ['max', 32]
    ])
    .addFluid('middle-ml', [
      ['lg', 'max', 6, 12],
      ['max', 12]
    ])
    .toCSS();
</script>

<nav class={responsiveVars}>
  <div class="left">
    <Logo />
  </div>
  <div class="bar" />
  <div class="middle">
    <slot />
  </div>

  <div class="right">
    {#if !brandReskinEnabled}
      <TwistBox display={{ min: 'none', lg: 'inline-flex' }}>
        <AccessibilityModalButton />
      </TwistBox>
    {/if}

    <TwistBox display={{ min: 'block', lg: 'none' }}>
      <MobileMenuButton />
    </TwistBox>
  </div>
</nav>

<style lang="scss">
  @import 'src/scss/variables';
  @import 'src/scss/media';

  nav {
    background: var(--twist-color-gray-100);
    border-radius: 1000px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-block: var(--nav-py);
    padding-right: var(--nav-pr);
    padding-left: var(--nav-pl);
    height: unset;
  }

  .left {
    display: flex;
    flex-direction: row;
    height: var(--left-size);
    width: var(--left-size);
    margin-right: var(--left-mr);
  }

  .bar {
    display: none;

    @include at('lg') {
      display: block;
      width: 0;
      border: 0.5px solid white;
      opacity: 0.4;
      height: var(--bar-height);
    }
  }

  .middle {
    display: none;

    @include at('lg') {
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;
      letter-spacing: 0.02em;
      margin-left: var(--middle-ml);
    }
  }
</style>
